import {dateToolTipAllergies } from './toolTipFormatter'
import HT from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import moment from 'moment'
HT(Highcharts)
const lineAreaChartOptions = (
  data,
  geo_id,
  locationName
) => {
  return {
    chart: {
      type: 'area'
  },
  accessibility: {
      description: ''
  },
  title: {
    text:''
     
  },
  legend: {
     align: 'right',
     verticalAlign: 'top',
      // itemMarginTop: -20,
   
  },
 credits:{
enabled:false
 },
  xAxis: {
    type: 'datetime',
      allowDecimals: false,
      accessibility: {
          rangeDescription: ''
      }
  },
  yAxis: {
      title: {
          text: ''
      }
  },

  plotOptions: {
      area: {
          // pointStart: 1940,
          marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                  hover: {
                      enabled: true
                  }
              }
          }
      }
  },
    tooltip: {
      shared: true,
      crosshairs: true,
      formatter:function(){
        {
          let toolTipHTML = ''
          const date = moment(this.x).format('MMM DD, YYYY')
        
          toolTipHTML+= `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
                  border-radius: 4px; font-family: 'Optum Sans', sans-serif;
                  font-style: normal;
                  font-weight: 700;
                  font-size: 14px;
                  ">
                  <div>${date}</div>
                  <div style="color:#002677;padding-top:5px">${locationName}</div>`
                  let legendSymbol
            this.points.forEach((point) => {  
              if (point.series.legendSymbol !== undefined) {
                let series = point.series
                legendSymbol =
                  "<svg width='16' height='16'>" +
                  series.legendSymbol.element.outerHTML +
                  point.series.legendSymbol.element.previousElementSibling.outerHTML +
                  '</svg>'
              } 
                 
              toolTipHTML+=`<div style='padding-top:5px'><span >${point.series.name}:</span> <span style='padding-left:10px;font-weight:400'>${point.y}</span></div>`
            })
           
            toolTipHTML+=`</div>          `
          return toolTipHTML
        }
      },
      borderRadius: 10,
      padding: 1,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0,
      },
    },
    series: data,

   
  }
}

export default lineAreaChartOptions
